import styled, { css } from 'styled-components';
import { colors } from 'utils/colors';

export const ContainerWrapperCalculadora = styled.div`
  min-width: 300px;
  justify-content: center;
  width: 100%;
  margin: 0 auto !important;
  display: flex;
  flex-wrap: wrap;
`;

export const ProdutoViewBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  max-width: 280px;
  min-width: 280px;
  width: 30%;
`;

export const BoxSelectProduto = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  label {
    font-size: 12px;
    font-weight: 600;
    color: ${colors.verde};
    text-transform: uppercase;
  }

  select {
    border: 1px solid ${colors.verde};
    color: ${colors.verde};
    border-radius: 5px;
    height: 30px;
    padding: 0 10px;
    margin-top: 6px;
  }
`;

export const ImgProdutoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 260px;
  padding: 15px;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const BoxPreviewImg = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const TilteProduto = styled.div`
  text-transform: uppercase;
  text-align: center;
  padding-top: 5px;
  color: ${colors.verde05};
`;
export const BoxTitleProduto = styled.div`
  font-size: 13px;
  color: ${colors.verde};
  font-weight: bold;
  text-transform: uppercase;
  margin-top: 10px;
  text-align: center;
`;
export const BoxTamanhoProduto = styled.div`
  text-align: center;
  text-transform: uppercase;
  font-size: 12px;
`;

export const CoresTiTle = styled.div`
  text-align: center;
  text-transform: uppercase;
  color: grey;
  font-size: 12px;
  margin-top: 10px;
  font-weight: 600;
`;
export const BoxVarianteCores = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;

export const Swatch = styled.span`
  display: block;
  width: 18px;
  height: 18px;
  border: 1px solid #d6d6d6;
  border-radius: 50%;
`;
export const BoxCores = styled.div`
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  li {
    margin: 0 6px 0 0;
    display: inline-block;
  }
  label {
    cursor: pointer;
  }
  input {
    display: none;
  }
  input[type='radio']:checked + ${Swatch} {
    box-shadow: inset 0 0 0 2px ${colors.branco};
    background-color: yellow;
  }
`;

export const BoxCalculadora = styled.div`
  width: 65%;
`;

export const BoxTaxasOpcoes = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid ${colors.verde05};
  flex-wrap: wrap;
  box-sizing: border-box;
`;

export const OpcoesWrapper = styled.div`
  width: 65%;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 200px;

  @media (max-width: 659px) {
    width: 100%;
    align-items: center;
  }
`;

export const BoxTaxasWrapper = styled.div`
  width: 35%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 150px;

  @media (max-width: 659px) {
    width: 100%;
    align-items: center;
  }
`;

export const BoxInputPrimario = styled.div`
  margin: 0px 0px 12px 0px;
  @media (max-width: 659px) {
    width: 100%;
  }
  label {
    font-size: 13px !important;
    color: ${colors.verde05};
    font-weight: bold;
    width: 135px;
    display: inline-block;
  }
  input {
    width: 200px;
    border: 1px solid ${colors.verde05};
    color: ${colors.verde05};
    border-radius: 5px;
    height: 30px;
    padding: 0 10px;
    @media (max-width: 659px) {
      width: 100%;
    }
  }
  select {
    width: 200px;
    border: 1px solid ${colors.verde05};
    color: ${colors.verde05};
    border-radius: 5px;
    height: 30px;
    padding: 0 10px;
    @media (max-width: 659px) {
      width: 100%;
    }
  }
`;

export const BoxInputSecundario = styled.div`
  margin: 0px 0px 12px 0px;
  label {
    font-size: 13px !important;
    color: ${colors.verde05};
    font-weight: bold;
    display: inline-block;
    width: 150px;
  }
  input {
    width: 75px;
    border: 1px solid ${colors.verde05};
    color: ${colors.verde05};
    border-radius: 5px;
    height: 30px;
    padding: 0 10px;
    @media (max-width: 659px) {
      width: 100%;
    }
  }
`;

export const BoxAjusteWrapper = styled.div`
  margin-top: 20px;
`;

export const SlideBoxWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TitleSlice = styled.div`
  font-size: 13px !important;
  color: ${colors.verde05};
  font-weight: bold;
`;

export const BoxRange = styled.div<{ end?: boolean }>`
  font-size: 12px;
  font-weight: 600;
  color: ${colors.verde05};
  width: 10%;

  ${(props) =>
    props.end &&
    css`
      text-align: flex-end;
    `}
`;

export const BoxResultado = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  flex-wrap: wrap;
`;

export const BoxCalculadoraWrapper = styled.div``;

export const TitlePrefixo = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: rgb(155, 155, 155);
  text-transform: uppercase;
`;

export const ResultadoCalculo = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #136033;
`;
